<div class="container virtual-tour">
	<iframe width="100%" frameborder="0" class="cmplazyload" src="about:blank" [attr.data-cmp-vendor]="Vendors.Wuppertal360" data-cmp-src="https://geschenkzeitung.wuppertal360.app/" ALLOWTRANSPARENCY="true"> </iframe>
	<p>
		<small>Drehen, zoomen, navigieren, klicken, vergrößern: Begebe Dich mit Deiner Maus auf einen <strong>virtuellen Rundgang durch unser Archiv</strong>. Ein Klick auf den blinkenden Pfeil bringt Dich in den nächsten Raum.</small>
	</p>
</div>
